import React from 'react';
import PropTypes from 'prop-types';
import humanFormat from 'human-format';
import classNames from 'classnames';
import styled from 'styled-components';
import dt from '../../../shared/theme';
import { recordStatisticsEvent } from '../../../services/statistics-service';
import StyledTooltip from './styled-tooltip';

const Button = styled.button`
  background-color: white;
  border-color: #d7dfe7;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 40px;
  outline: none;

  &.pressed {
    border-color: ${props => dt(props).theme.primaryColor};
  }

  & > .icon-lw {
    margin-top: -4px;
    text-align: right;
    color: ${props => dt(props).theme.bodyColor};
  }

  & > .number,
  & > .text {
    color: ${props => dt(props).theme.bodyColor};
    font: ${props => dt(props).theme.fontWeightHeavy} 16px/19.2px ${props => dt(props).theme.fontFamilyBody};
  }
  & > .number {
    text-align: center;
    margin: 0 6px;
  }

  & > .text {
    margin-left: 4px;
  }

  & > .number + .text {
    margin-left: 0;
  }
`;

const getNumber = c => humanFormat(c, { decimals: 1, separator: '' });

export default function CommentToggleButton({ active, wire, onToggle }) {
  const [pressed, setPressed] = React.useState(false);
  const count = wire.commentCount;
  const iconCls = {
    'icon-lw-comment': !active,
    'icon-lw-comment-active': active,
  };

  const toggle = e => {
    e && e.preventDefault();
    if (!active) {
      recordStatisticsEvent({
        event: 'wire_mobile_comments_clicked',
        statisticable: 'wire',
        id: wire.id,
        page: window.location.pathname,
      });
    }
    onToggle(!active);
  };

  const num = getNumber(count);

  return (
    <StyledTooltip
      disableTouchListener
      title="Comment on wire"
      enterDelay={300}
    >
      <Button
        className={classNames('btn', { pressed })}
        type="button"
        onClick={toggle}
        onMouseDown={() => setPressed(true)}
        onMouseUp={() => setPressed(false)}
      >
        <span className={classNames('icon-lw', iconCls)} />
        {!!count && <span className="number">{num}</span>}
      </Button>
    </StyledTooltip>
  );
}

CommentToggleButton.propTypes = {
  active: PropTypes.bool.isRequired,
  wire: PropTypes.shape({
    commentCount: PropTypes.number.isRequired,
    id: PropTypes.number.isRequired,
  }).isRequired,
  onToggle: PropTypes.func.isRequired,
};
